import {Scene} from "phaser";
import {BaseAnimation} from "./BaseAnimation";

export class Dude implements BaseAnimation
{
    private scene: Scene;


    constructor(scene: Scene)
    {
        this.scene = scene;
    }

    generateFrames(): void
    {
        this.scene.anims.create({
            key: "jumpAnimationLeft",
            frames: [
                {key: "jump1_L", frame: null},
                {key: "jump2_L", frame: null},
                {key: "jump3_L", frame: null},
                {key: "jump4_L", frame: null},
                {key: "jump5_L", frame: null},
                {key: "jump6_L", frame: null},
                {key: "jump7_L", frame: null}
            ],
            frameRate: 6,
            repeat: -1
        });

        this.scene.anims.create({
            key: "jumpAnimationRight",
            frames: [
                {key: "jump1_R", frame: null},
                {key: "jump2_R", frame: null},
                {key: "jump3_R", frame: null},
                {key: "jump4_R", frame: null},
                {key: "jump5_R", frame: null},
                {key: "jump6_R", frame: null},
                {key: "jump7_R", frame: null}
            ],
            frameRate: 6,
            repeat: -1
        });

        this.scene.anims.create({
            key: "walkLeft",
            frames: [
                {key: "walk1_L", frame: null},
                {key: "walk2_L", frame: null},
                {key: "walk3_L", frame: null},
                {key: "walk4_L", frame: null}
            ],
            frameRate: 6,
            repeat: -1
        });

        this.scene.anims.create({
            key: "walkRight",
            frames: [
                {key: "walk1_R", frame: null},
                {key: "walk2_R", frame: null},
                {key: "walk3_R", frame: null},
                {key: "walk4_R", frame: null}
            ],
            frameRate: 6,
            repeat: -1
        });

        this.scene.anims.create({
            key: "stayAnimationLeft",
            frames: [
                {key: "stay1_L", frame: null},
                {key: "stay2_L", frame: null},
                {key: "stay3_L", frame: null},
                {key: "stay4_L", frame: null}
            ],
            frameRate: 6,
            repeatDelay: 500,
            repeat: -1
        });

        this.scene.anims.create({
            key: "stayAnimation",
            frames: [
                {key: "stay1", frame: null},
                {key: "stay2", frame: null},
                {key: "stay3", frame: null},
                {key: "stay4", frame: null}
            ],
            frameRate: 6,
            repeatDelay: 500,
            repeat: -1
        });

        this.scene.anims.create({
            key: "upAnimation",
            frames: [
                {key: "up1", frame: null},
                {key: "up2", frame: null}
            ],
            frameRate: 6,
            repeat: -1
        });

        this.scene.anims.create({
            key: "sideRightImage",
            frames: [
                {key: "sideRight", frame: null},
            ],
        });

        this.scene.anims.create({
            key: "backImage",
            frames: [
                {key: "rotBack", frame: null},
            ],
        });
    }

    loadImages(): void
    {
        /* jump to left */
        this.scene.load.image("jump1_L", "assets/dude/jumpleft/jump_1.png");
        this.scene.load.image("jump2_L", "assets/dude/jumpleft/jump_2.png");
        this.scene.load.image("jump3_L", "assets/dude/jumpleft/jump_3.png");
        this.scene.load.image("jump4_L", "assets/dude/jumpleft/jump_4.png");
        this.scene.load.image("jump5_L", "assets/dude/jumpleft/jump_5.png");
        this.scene.load.image("jump6_L", "assets/dude/jumpleft/jump_6.png");
        this.scene.load.image("jump7_L", "assets/dude/jumpleft/jump_7.png");

        /* jump to right */
        this.scene.load.image("jump1_R", "assets/dude/jump/jump_1.png");
        this.scene.load.image("jump2_R", "assets/dude/jump/jump_2.png");
        this.scene.load.image("jump3_R", "assets/dude/jump/jump_3.png");
        this.scene.load.image("jump4_R", "assets/dude/jump/jump_4.png");
        this.scene.load.image("jump5_R", "assets/dude/jump/jump_5.png");
        this.scene.load.image("jump6_R", "assets/dude/jump/jump_6.png");
        this.scene.load.image("jump7_R", "assets/dude/jump/jump_7.png");

        /* stay left */
        this.scene.load.image("stay1_L", "assets/dude/stayleft/stay_1.png");
        this.scene.load.image("stay2_L", "assets/dude/stayleft/stay_2.png");
        this.scene.load.image("stay3_L", "assets/dude/stayleft/stay_3.png");
        this.scene.load.image("stay4_L", "assets/dude/stayleft/stay_4.png");

        /* stay right */
        this.scene.load.image("stay1", "assets/dude/stay/stay_1.png");
        this.scene.load.image("stay2", "assets/dude/stay/stay_2.png");
        this.scene.load.image("stay3", "assets/dude/stay/stay_3.png");
        this.scene.load.image("stay4", "assets/dude/stay/stay_4.png");

        /* walk to left */
        this.scene.load.image("walk1_L", "assets/dude/walkleft/walk_1.png");
        this.scene.load.image("walk2_L", "assets/dude/walkleft/walk_2.png");
        this.scene.load.image("walk3_L", "assets/dude/walkleft/walk_3.png");
        this.scene.load.image("walk4_L", "assets/dude/walkleft/walk_4.png");

        /* walk to right */
        this.scene.load.image("walk1_R", "assets/dude/walk/walk_1.png");
        this.scene.load.image("walk2_R", "assets/dude/walk/walk_2.png");
        this.scene.load.image("walk3_R", "assets/dude/walk/walk_3.png");
        this.scene.load.image("walk4_R", "assets/dude/walk/walk_4.png");

        /* up */
        this.scene.load.image("up1", "assets/dude/up/up_1.png");
        this.scene.load.image("up2", "assets/dude/up/up_2.png");

        /* rot */
        this.scene.load.image("sideRight", "assets/dude/rot/rot_1.png");
        this.scene.load.image("rotBack", "assets/dude/up/up_1.png");

    }


}
